import { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useContentDimensions from '../../../hooks/use-content-dimensions';
import useHoverPosition from '../../../hooks/use-hover-position';
import styles from './chart-container.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

const ChartContainer = ({
  alt,
  height,
  onHover,
  onHoverEnd,
  onHoverStart,
  onResize,
  src
}) => {
  const ref = useRef(null);

  const { width } = useContentDimensions(ref);

  useHoverPosition({
    containerRef: ref,
    onHoverStart,
    onHover,
    onHoverEnd
  });

  useLayoutEffect(() => {
    onResize(width);
  }, [width]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div ref={ref} style={{ height }} {...className('print-chart-container')}>
        {src && <img alt={alt} src={src} {...className('chart-img-size-fixed')} />}
      </div>
    </>
  );
};

ChartContainer.propTypes = {
  alt: PropTypes.string,
  height: PropTypes.number,
  onResize: PropTypes.func,
  onHover: PropTypes.func,
  onHoverEnd: PropTypes.func,
  onHoverStart: PropTypes.func,
  src: PropTypes.string
};

export default ChartContainer;
